// extracted by mini-css-extract-plugin
module.exports = {"two-stories-wrapper":"row2-m__two-stories-wrapper__2IShF","base":"row2-m__base__3AqR1"};